import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, getDocs } from 'firebase/firestore';
// import Swal from 'sweetalert2';
import { DB } from '~/services/firebase';

import Admin from '~/layouts/Admin';
import ICompany from '~/interfaces/ICompany';

const placeholder =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAMFBMVEXx8/XCy9K/yND09vfw8vTP1tzp7O/i5ure4+fO1dvJ0dfT2d/EzNPt7/Lb4OXo6+4FeM7UAAAFL0lEQVR4nO2c24KrIAxFLdha7///t0dxOlWDSiAKztnrbR4G6SoJBKHZA6zJYncgQeCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ocEKBEwqcUOCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ot3Oi1KMq64FnWTVq+EueWzlRquqKVn/J+/ezEfdyHydKPYtc62yF1m1Xymq5ixPVdDnx8eslf1eCVu7hRFXFppAfLW39kNJyByeqOTJirGTvRsbKDZyozsHIpKUQsZK8E1Vu55GTrKTuRL0ZRoyVLviZaTtRVctUMuaVOnCoJO1E1WwjxsorbGZO2Qk7br5WuhApKTvpfZWMy5WAoZKuk6b1NhI4VJJ10uRBSsas0ng+OlUnVaARw9NvqCTqRERJpt9eUtJ0IqPEN36SdNIIKRnIPeafFJ0Ep9c5mr+qTdFJ2CRMpLAn5fScqJeokrFWZkoRdaImwtpw2T9iSnnxuiDoRFXda6hK28JzWTA14ryBxKFlTT9iTlT1W57o3Lta96yED8krRieknCw/DDuEP1TnKBlgzMlCTtZDXr+8pIjOwitK5x7JOKFD3mukiE85ix45S5FxYll46prdiv8ekpsU19wv4kS9LV1ouQPlrPzKliIzTuw9YDYiVfgFSxFx8rR+wcyMomSX9HYpTjlFwonqrB3gBc/JyYQjRcRJYe8Ay4l9rMlLcVi8iTjp7Y/nOBHcMjngWEoi4+TUlcmKw9rnxHzCWMqeU/ltkB9JEZl3SusnYmwQn1fm2GgPeiOzZrM9WZfu/3/BNDznYATLOLENffep+JppeMZBMSZUF9N6ljFM7KF3qpTduBZyQj4W53XTiRsEm1L2dr2k9k9W9Rtjq2BrJj9Zyk7pI7bP9lw8kfH+4KIFLGF77Sa3R90Un0POvHNCcYzsLVMk9+2buni1bd9xjMSJHMPmjCz7zov/fidW5GQ7OS/2e8BoRrLtrBfXScTIMVLsk09cJxEjZ8I6+cR1EmG1tsRaDsZ0EjlyDL0leuxOpulD4JTALtfXORRbnqVO1LDOePdtpoclWPsqulL+wt0P0SNnxFKrrp2opmuXl+5OuHA3PSmByDGQ9ezSydYdM+ELd4YUIsdANnoWTva2RSUv3JlnJRE5I2RbY+6kee1+dTrrhC7cPTZeMUdivZnydaIc3tdqqWuI6USOYZlSfp0oxzVlJxNByUSOYZlSPk6cDzqEXy17JDTn/LBMKRlTSRZ4X2giep2zZnEwZHLiGjifFt6BTtKKHMMspUxO2BkvDzoDm1jkGGa7bsaJx0t9XfgrOfuMlhezwsc48RrKufvhyiXXHatg8T2Zkm0eHzluxO8W4pXHKljkXycBt3h9blFdeqyCx2fPOguLbn6qTWsBu+Czxs/CopsdP4kmkx+mcZ8FRrfuWUqSTSYT005keDucW4iXnzRhMg17iYacC6A0VyZzzIQs0pBrUrn22JoXY4Us0pDjaZMzb+dIMX6/Qi0dHSU0XHySz48heqSaOs60vsvlq2mtpzj9OCh/Trgjew7afgLar63d6ec2SmTZm37+UyV7048K+Gmkm7O10A/8aaSbY7sEr8rYvYoNnX4Sr3EuYJVpVc35Ccu/innZbryMJ1n4v9f4N9FZ39XPZ931GYzMGH9VPHYfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADp8Q9+nG9anuOrfAAAAABJRU5ErkJggg==';

const Companies: React.FC = () => {
  const [companies, setCompanies] = useState<ICompany[]>([]);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('Todos');
  const [showFilter, setShowFilter] = useState(false);

  const load = useCallback(async () => {
    const q = query(collection(DB, 'companies'));
    const querySnapshot = await getDocs(q);

    const items: ICompany[] = [];

    querySnapshot.docs.forEach(item => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as ICompany;

      items.push(parseItem);
    });

    setCompanies(items);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const filteredCompanies = useMemo(() => {
    const filtered = companies.filter(company => {
      let result = true;

      if (status === 'Ativo') {
        result =
          company.fantasy
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) && company.status === true;
      } else if (status === 'Inativo') {
        result =
          company.fantasy
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) && company.status === false;
      } else {
        result = company.fantasy
          .toLocaleLowerCase()
          .includes(search.toLocaleLowerCase());
      }

      return result;
    });
    return filtered;
  }, [search, companies, status]);

  // const handleConfirmRemove = useCallback(
  //   async (id: string) => {
  //     const { isConfirmed } = await Swal.fire({
  //       title: 'Atenção!',
  //       text: 'Confirme a exclusão da categoria?',
  //       icon: 'warning',
  //       confirmButtonText: 'Sim',
  //       showCancelButton: true,
  //       cancelButtonText: 'Não',
  //     });

  //     if (isConfirmed) {
  //       await deleteDoc(doc(DB, 'categories', id));

  //       loadCategories();

  //       addToast({
  //         type: 'success',
  //         description: 'Categoria foi removida com sucesso.',
  //       });
  //     }
  //   },
  //   [addToast, loadCategories],
  // );

  return (
    <Admin>
      <div className="col-xl-8 offset-xl-2">
        <div className="nk-block-head nk-block-head-sm">
          <div className="nk-block-between">
            <div className="nk-block-head-content">
              <h3 className="nk-block-title page-title">Estabelecimentos</h3>
            </div>
            <div className="nk-block-head-content">
              <div className="toggle-wrap nk-block-tools-toggle">
                <button
                  type="button"
                  className={`btn btn-icon btn-trigger toggle-expand mr-n1 ${
                    showFilter && 'active'
                  }`}
                  data-target="pageMenu"
                  onClick={() => setShowFilter(current => !current)}
                >
                  <em className="icon ni ni-more-v" />
                </button>
                <div
                  className={`toggle-expand-content ${
                    showFilter && 'expanded'
                  }`}
                  data-content="pageMenu"
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <em className="icon ni ni-search" />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Buscar por estabelecimento"
                          onChange={event => {
                            setSearch(event.target.value);
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="drodown">
                        <Link
                          to="#status"
                          className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                          data-toggle="dropdown"
                        >
                          {status}
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                          <ul className="link-list-opt no-bdr">
                            <li>
                              <Link
                                to="#status"
                                onClick={() => setStatus('Todos')}
                              >
                                <span>Todos</span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#active"
                                onClick={() => setStatus('Ativo')}
                              >
                                <span>Ativo</span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#inactive"
                                onClick={() => setStatus('Inativo')}
                              >
                                <span>Inativo</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    {/* <li className="nk-block-tools-opt">
                      <Link
                        to="/companies/create"
                        data-target="addProduct"
                        className="toggle btn btn-icon btn-primary d-md-none"
                      >
                        <em className="icon ni ni-plus" />
                      </Link>
                      <Link
                        to="/companies/create"
                        data-target="addProduct"
                        className="toggle btn btn-primary d-none d-md-inline-flex"
                      >
                        <em className="icon ni ni-plus" />
                        <span>Cadastrar</span>
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="nk-block">
          <div className="card card-bordered">
            <div className="card-inner-group">
              <div className="card-inner p-0">
                <div className="nk-tb-list">
                  <div className="nk-tb-item nk-tb-head">
                    <div className="nk-tb-col">
                      <span>Nome</span>
                    </div>
                    <div className="nk-tb-col">
                      <span>Contato</span>
                    </div>
                    <div className="nk-tb-col">
                      <span>Status</span>
                    </div>

                    <div className="nk-tb-col nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1 my-n1">
                        <li className="mr-n1" />
                      </ul>
                    </div>
                  </div>

                  {filteredCompanies.map(item => (
                    <div className="nk-tb-item" key={item.uid}>
                      <div className="nk-tb-col">
                        <span className="tb-product">
                          <img
                            src={item.image ? item.image : placeholder}
                            alt="estabelecimento"
                            className="thumb"
                          />
                          <span className="title">{item.fantasy}</span>
                        </span>
                      </div>

                      <div className="nk-tb-col">
                        <div className="asterisk tb-asterisk">
                          <span className="title fs-12px">{item.phone}</span>
                        </div>
                      </div>

                      <div className="nk-tb-col">
                        <div className="asterisk tb-asterisk">
                          <span
                            className={`text-${
                              item.status ? 'success' : 'danger'
                            } fs-12px`}
                          >
                            {item.status && <span>Ativo</span>}
                            {!item.status && <span>Inativo</span>}
                          </span>
                        </div>
                      </div>
                      <div className="nk-tb-col nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1 my-n1">
                          <li className="mr-n1">
                            <div className="dropdown">
                              <Link
                                to="#options"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                                data-toggle="dropdown"
                              >
                                <em className="icon ni ni-more-h" />
                              </Link>
                              <div className="dropdown-menu dropdown-menu-right">
                                <ul className="link-list-opt no-bdr">
                                  <li>
                                    <Link to={`/companies/edit/${item.uid}`}>
                                      <em className="icon ni ni-edit" />
                                      <span>Editar</span>
                                    </Link>
                                  </li>

                                  {/* <li>
                                    <Link
                                      to="#remove"
                                      onClick={() =>
                                        handleConfirmRemove(item.uid)}
                                    >
                                      <em className="icon ni ni-trash" />
                                      <span>Excluir</span>
                                    </Link>
                                  </li> */}
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Admin>
  );
};

export default Companies;
